import { Moment } from 'moment';
import User from '@/shared/models/User';

export class Coordinates {
  static DEFAULT = new Coordinates(50.84673777442272, 4.352418103793321);

  constructor(
    readonly latitude: number,
    readonly longitude: number,
  ) {
  }

  get latLng(): { lat: number; lng: number } {
    return { lat: this.latitude, lng: this.longitude };
  }
}

export default class Location {
  description: string | null = null;
  coordinates: Coordinates | null = null;
  modifiedOn: Moment | null = null;
  modifiedBy: User | null = null;

  static create(description: string | null, coordinates: Coordinates | null, modifiedOn?: Moment, modifiedBy?: User): Location {
    const location = new Location();
    location.description = description;
    location.coordinates = coordinates;
    location.modifiedOn = modifiedOn ?? null;
    location.modifiedBy = modifiedBy ?? null;
    return location;
  }

  isEqualTo(coordinates: Coordinates | null, description: string | null): boolean {
    return this.description === description && this.coordinates === coordinates;
  }
}
